import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import EntryPicker from 'focus_groups/components/entry_picker';
import { toggleSelectedEntries, toggleAddModal, setEntries,
  changeAddModalStep } from 'focus_groups/ducks/view_state';

export function mapStateToProps({ project: { focusGroups } }) {
  return {
    ...focusGroups.viewState,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleAddModal,
    toggleEntry: toggleSelectedEntries,
    onBack: partial(changeAddModalStep, 1),
    onNext: partial(changeAddModalStep, 3),
    setEntries,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EntryPicker);



// WEBPACK FOOTER //
// ./focus_groups/containers/entry_picker.js